/**
 * Cart popup autohandler.
 *
 * Usage:
 *
 *  data-sw-form
 */

var $ = require('./../sw-jquery');
var ShapewaysFormView = require('./../../lib/views/ShapewaysFormView');

module.exports = function($fragment) {

	$fragment.swFindWithSelf(ShapewaysFormView.prototype.swSelectors.ROOT).each(function() {
    var $el = $(this);

    new ShapewaysFormView({
      el: $el
    });
  });

};